import {signal} from '@preact/signals-react';

export const labelClipDraggingLeftSignal = signal<number | null>(null);
